import { render, staticRenderFns } from "./TheMasthead.vue?vue&type=template&id=8545ecf2&scoped=true&"
import script from "./TheMasthead.vue?vue&type=script&lang=js&"
export * from "./TheMasthead.vue?vue&type=script&lang=js&"
import style0 from "./TheMasthead.vue?vue&type=style&index=0&id=8545ecf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8545ecf2",
  null
  
)

export default component.exports